<template>
  <v-container class="pt-0">
    <v-container fluid class="pa-0">
      <v-btn-toggle
        v-if="status != null && dataItems.length > 0"
        v-model="toggle_view"
        mandatory
        :color="site.color"
        style="
          text-align: end;
          display: flow;
          border-radius: 20px;
          background-color: transparent;
          padding-right: 4px;
        "
        class="pa-0"
      >
        <v-btn small>
          <v-icon :color="toggle_view == 0 ? site.color : ''" small
            >mdi-view-headline</v-icon
          >
        </v-btn>
        <v-btn small>
          <v-icon :color="toggle_view == 1 ? site.color : ''" small
            >mdi-view-grid-outline</v-icon
          >
        </v-btn>
      </v-btn-toggle>
    </v-container>

    <v-row class="mt-1" v-if="toggle_view == 0">
      <v-col
        class="px-2 py-2"
        cols="6"
        sm="4"
        lg="2"
        md="3"
        v-for="(item, index) in dataItems"
        :key="index"
      >
        <div>
          <v-card
            class="rounded-lg pa-3 pb-6 card-container"
            outlined
            elevation="1"
            width="100%"
            style="border: none"
            @click="redirectTo(item)"
          >
            <!-- point -->
            <div
              v-if="item.limit_reached"
              class="d-flex justify-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("limitReached") }}</div>
            </div>
            <!-- date -->
            <div
              v-else-if="item.in_period_remind_date"
              class="d-flex justify-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("textComingSoon") }}</div>
            </div>
            <!-- frequency -->
            <div
              v-else-if="!item.in_period_show_time_selected"
              class="d-flex justify-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("textTimeCannotJoin") }}</div>
            </div>

            <!-- content -->
            <v-img
              :lazy-src="require('@/assets/images/image.png')"
              :cover="true"
              :aspect-ratio="1"
              width="100%"
              :src="item.image_url"
              style="max-height: 200px"
            >
            </v-img>
            <p
              v-if="item"
              class="title-mission text-start mb-auto text-subtitle-2 black--text"
              v-snip="{ lines: 2 }"
              :style="{
                'min-height': isOverview ? '48px' : '84px',
              }"
            >
              {{ item.name }}
            </p>
            <v-skeleton-loader
              v-else
              type="list-item-two-line"
            ></v-skeleton-loader>
            <div v-if="!isOverview">
              <p
                v-if="$route.params.status == '3'"
                class="title-mission text-start mb-auto black--text"
                style="font-size: 12px"
                v-snip="{ lines: 2 }"
              >
                {{ $t("note") }}: {{ item.note }}
              </p>

              <div
                v-if="$route.params.status != '3'"
                class="bottomleft d-flex align-center"
                style="width: 100%"
              >
                <div v-if="item.use_reward == false" class="pb-0 pr-1">
                  <PointSymbol
                    v-if="Array.isArray(item.point) && item.point.length > 0"
                    :type="item.point[0].point_type_type"
                    :symbol="item.point[0].point_type_symbol"
                    :color="item.point[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="28"
                  />
                </div>
                <v-icon class="pb-0 pr-1" :color="site.color" left v-else
                  >mdi-gift</v-icon
                >
                <p
                  class="mb-0 text-start text-subtitle-2 pl-0 text-truncate"
                  style="width: calc(100% - 56px)"
                  :style="{ color: site.color }"
                >
                  {{ showPoint(item) }}
                </p>
              </div>
            </div>
            <div v-else>
              <div
                v-if="item.summary_status"
                :style="{ paddingTop: isOverview ? '4px' : '0' }"
              >
                <v-col cols="12" class="pa-0" style="position: relative">
                  <div
                    v-for="(value, key) in item.summary_status"
                    :key="key"
                    class="d-flex align-center justify-space-between my-1"
                  >
                    <span class="text-caption">
                      <v-icon
                        :color="getStyle(key)[0].color"
                        small
                        class="mr-1"
                      >
                        {{ getStyle(key)[0].icon }}
                      </v-icon>
                      {{ $t(key) }}
                    </span>

                    <span style="font-weight: bolder" class="text-caption">
                      {{ (value ?? 0) | commaPoint }}
                    </span>
                  </div>
                  <div
                    v-for="(item_reward, index_reward) in getTotalReward(item)
                      .list"
                    :key="index_reward"
                  >
                    <div
                      v-if="item_reward.type == 'reward'"
                      class="d-flex align-center justify-space-between my-1"
                    >
                      <div
                        class="d-flex align-center"
                        style="gap: 8px; overflow: hidden"
                      >
                        <v-img
                          :lazy-src="require('@/assets/images/image.png')"
                          :cover="true"
                          :aspect-ratio="1"
                          width="16"
                          :src="item_reward.reward_image"
                          style="
                            max-width: 16px;
                            max-height: 16px;
                            border-radius: 4px;
                          "
                        >
                        </v-img>
                        <span class="text-caption text-truncate">
                          {{ item_reward.reward_name }}
                        </span>
                      </div>

                      <span style="font-weight: bolder" class="text-caption">
                        {{ (item_reward.reward_amount || 0) | commaPoint }}
                      </span>
                    </div>

                    <div
                      v-if="item_reward.type == 'point'"
                      class="d-flex align-center justify-space-between my-1"
                    >
                      <div
                        class="d-flex align-center"
                        style="width: calc(100% - 64px); gap: 8px"
                      >
                        <PointSymbol
                          :type="item_reward.point_type_type"
                          :symbol="item_reward.point_type_symbol"
                          :color="item_reward.point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="16"
                        />
                        <p
                          class="text-caption text-truncate mb-0"
                          style="width: 100%"
                        >
                          {{ item_reward.point_type_name }}
                        </p>
                      </div>

                      <span style="font-weight: bolder" class="text-caption">
                        {{ (item_reward.point || 0) | commaPoint }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="
                      !getTotalReward(item).list ||
                      getTotalReward(item).list.length == 0
                    "
                    style="height: 24px"
                  ></div>
                  <div
                    style="
                      position: absolute;
                      z-index: 1;
                      bottom: -20px;
                      width: 100%;
                    "
                  >
                    <div
                      v-if="getTotalReward(item).more"
                      class="d-flex justify-end"
                      @click="viewTotalRewarMore($event, item, true)"
                    >
                      <v-chip
                        x-small
                        color="blue"
                        outlined
                        style="border-radius: 4px"
                      >
                        {{
                          $t("textNumberMore", {
                            number: item.total_reward.length - 1,
                          })
                        }}
                      </v-chip>
                    </div>
                    <div
                      v-else-if="item.active_view_more"
                      class="d-flex justify-end"
                      @click="viewTotalRewarMore($event, item, false)"
                    >
                      <v-chip
                        x-small
                        color="orange"
                        outlined
                        style="border-radius: 4px"
                      >
                        {{ $t("textHide") }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-2" v-else>
      <v-col
        class="px-2 py-2"
        cols="6"
        sm="4"
        lg="2"
        md="3"
        v-for="(item, index) in dataItems"
        :key="index"
      >
        <div>
          <v-card
            class="rounded-lg pa-3 card-container"
            outlined
            elevation="1"
            width="100%"
            style="border: none"
            @click="redirectTo(item)"
            :style="item.total > 1 ? layeredShadow(site.color) : {}"
          >
            <v-chip
              small
              style="position: absolute; z-index: 10; right: 6px"
              :color="site.color"
              dark
              v-if="item.total > 1"
            >
              <span style="font-weight: bold">
                {{ $t("amount") }} :
                {{ item.total }}
              </span>
            </v-chip>
            <!-- point -->
            <div
              v-if="item.limit_reached"
              class="d-flex justify-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("limitReached") }}</div>
            </div>
            <!-- date -->
            <div
              v-else-if="item.in_period_remind_date"
              class="d-flex justify-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("textComingSoon") }}</div>
            </div>
            <!-- frequency -->
            <div
              v-else-if="!item.in_period_show_time_selected"
              class="d-flex justify-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("textTimeCannotJoin") }}</div>
            </div>

            <!-- content -->
            <v-img
              :lazy-src="require('@/assets/images/image.png')"
              :cover="true"
              :aspect-ratio="1"
              width="100%"
              :src="item.image_url"
              style="max-height: 200px"
            >
            </v-img>
            <p
              v-if="item"
              class="title-mission text-start mb-auto text-subtitle-2 black--text"
              v-snip="{ lines: 2 }"
              :style="{
                'min-height': isOverview ? '48px' : '84px',
              }"
            >
              {{ item.name }}
            </p>
            <v-skeleton-loader
              v-else
              type="list-item-two-line"
            ></v-skeleton-loader>
            <p
              v-if="$route.params.status == '3'"
              class="title-mission text-start mb-auto black--text"
              style="font-size: 12px"
              v-snip="{ lines: 2 }"
            >
              {{ $t("note") }}: {{ item.note }}
            </p>
            <div
              v-if="$route.params.status != '3'"
              class="bottomleft d-flex align-center"
              style="width: 100%"
            >
              <div v-if="item.use_reward == false" class="pb-0 pr-1">
                <PointSymbol
                  v-if="Array.isArray(item.point) && item.point.length > 0"
                  :type="item.point[0].point_type_type"
                  :symbol="item.point[0].point_type_symbol"
                  :color="item.point[0].point_type_color"
                  :is_display="true"
                  :outlined_box="false"
                  :size="28"
                />
              </div>
              <v-icon class="pb-0 pr-1" :color="site.color" left v-else
                >mdi-gift</v-icon
              >
              <p
                class="mb-0 text-start text-subtitle-2 pl-0 text-truncate"
                style="width: calc(100% - 56px)"
                :style="{ color: site.color }"
              >
                {{ showPoint(item) }}
              </p>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <DialogDetail
      v-if="dialogDetail"
      :item="item"
      :keyComponent="keyComponent"
      :dialogDetail="dialogDetail"
      :site="site"
      :typeActivity="typeActivity"
      @close="dialogDetail = false"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import DialogDetail from "./activity/dialogDetail.vue";
import PointSymbol from "./point/point-symbol.vue";

export default {
  props: ["dataItems", "site", "typeActivity", "status", "isOverview"],
  data() {
    return {
      model: 0,
      dialogDetail: false,
      item: "",
      keyComponent: 0,
      loaded: true,
      toggle_view: 0,
    };
  },
  components: { DialogDetail, PointSymbol },
  methods: {
    layeredShadow(color) {
      const hex = color.replace("#", "");
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return {
        // border: `1px solid rgba(0,0,0,.87)`,
        boxShadow: `0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14), rgba(${r}, ${g}, ${b}, 0.3) 5px -5px, rgba(${r}, ${g}, ${b}, 0.2) 10px -10px !important`,
      };
    },
    redirectTo(item) {
      if (this.typeActivity) {
        this.item = item;
        this.dialogDetail = true;
        this.keyComponent++;
        return;
      }

      if (
        this.status != 0 &&
        typeof this.status !== "undefined" &&
        item.employee_missions_id != ""
      ) {
        if (item.type == "lucky draw") {
          this.$router.push({
            name: "mission-detail",
            params: { id: item.employee_missions_id, status: "all" },
          });
          return;
        } else {
          this.$router.push({
            name: "my-mission-detail",
            params: {
              status: this.status,
              id: item.employee_missions_id,
            },
            query: {
              from: this.status,
              // ...(this.routePrevious && { routePrevious: this.routePrevious }),
            },
          });
          return;
        }
      }

      if (moment().isAfter(item.end_date)) {
        this.$swal.fire({
          icon: "error",
          text: this.$t("errExpireActivity"),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      if (item.employee_missions_id === "") {
        this.$router.push({
          name: "mission-detail",
          params: { id: item.id, status: "all" },
        });
        return;
      } else if (item.mission_type === "multi-upload") {
        if (item.mission_status_text === "waiting") {
          this.$router.push({
            name: "mission-detail",
            params: { id: item.id, status: "all" },
          });
        } else {
          this.$router.push({
            name: "my-mission-detail",
            params: {
              status: this.status,
              id: item.employee_missions_id,
            },
            query: {
              from: this.status,
            },
          });
        }
        return;
      } else {
        this.$router.push({
          name: "my-mission-detail",
          params: {
            status: this.status,
            id: item.employee_missions_id,
          },
          query: {
            from: this.status,
          },
        });
        return;
      }
    },
    showPoint(param) {
      let pointDetail = {
        point: 0,
        point_type_name: "",
      };
      if (Array.isArray(param.point) && param.point.length > 0) {
        pointDetail = param.point[0];
      }
      if (param.use_reward == true) {
        return `${this.$t("rewardPrize")}`;
      } else if (pointDetail.point == 0 || param.type == "check-in") {
        return `${this.$t("conditionCoin")}`;
      } else if (Array.isArray(param.point) && param.point.length > 1) {
        // return `${this.$t("textNumberMore", { number: param.point.length })}`;
        return `+${param.point.length}`;
      } else {
        const formattedPoint = this.$options.filters.commaPoint(
          pointDetail.point
        );
        return `${formattedPoint} ${pointDetail.point_type_name}`;
      }
    },
    getStyle(status) {
      switch (status) {
        case "joined":
          return [
            {
              bgColor: "#E3F2FD",
              color: "blue",
              icon: "mdi-account-reactivate-outline",
            },
          ];
        case "waiting":
          return [
            {
              bgColor: "#FFF3E0",
              color: "orange",
              icon: "mdi-clock-outline",
            },
          ];
        case "success":
          return [
            {
              bgColor: "#E8F5E9",
              color: "green",
              icon: "mdi-check-circle-outline",
            },
          ];

        case "failed":
          return [
            {
              bgColor: "#FFEBEE",
              color: "red",
              icon: "mdi-close-circle-outline",
            },
          ];

        default:
          break;
      }
    },
    getTotalReward(param) {
      const list = param.total_reward || [];
      const isMoreThanOne = list.length > 1;
      const activeViewMore = param.active_view_more || false;

      return {
        list: activeViewMore ? list : list.slice(0, 1),
        more: isMoreThanOne && !activeViewMore,
      };
    },
    viewTotalRewarMore(event, param, view) {
      event.stopPropagation();
      this.$set(param, "active_view_more", view);
    },
  },
  updated() {
    this.loaded = false;
  },
  computed: {},
  mounted() {},
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  watch: {
    toggle_view: {
      handler() {
        this.$emit("view", this.toggle_view);
      },
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  /* min-height: 276px; */
  /* aspect-ratio: 1 / 1.5; */
  min-height: clamp(276px, 40vw, 320px);
}
.disabled-card {
  /* background-color: #00000033; */
}

.bottomleft {
  position: absolute;
  bottom: 12px;
  left: 12px;
  font-size: 18px;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 80px 0px 0px 0px;
  width: 75%;
  height: fit-content;
  text-align: center;
}

::v-deep .v-skeleton-loader__list-item-two-line {
  padding: 0px !important;
}
</style>
